// @flow
import React, { type Node } from 'react';


type Props = {
  num: number,
  contentSubject?: Node,
  contentMain?: Node,
  contentMarks?: Node,
}

const ScheduleRowTemplate = ({ num, contentSubject, contentMain, contentMarks }: Props): Node => {
  return (
    <tr>
      <td>{`${num}.`}</td>
      <td>{contentSubject}</td>
      <td>{contentMain}</td>
      <td>{contentMarks}</td>
    </tr>

  );
};

export default ScheduleRowTemplate;
